import Anchor from 'components/typography/anchor';
import { PricesPropType } from 'utilities/propTypes';

export const PremiumFeaturesTable = ({ prices }) => (
  <>
    <h2 className="mt-4 text-center">
      Free <em>vs.</em> Premium
    </h2>
    <div className="mt-4 flex flex-wrap gap-2 sm:flex-nowrap">
      <ul
        className="card-flat block list-disc space-y-1 p-8 text-sm marker:text-stone-300 before:text-lg before:font-bold before:content-[attr(aria-label)] sm:basis-1/2 dark:marker:text-stone-600"
        aria-label="Free"
      >
        <li className="list-none text-lg">$0</li>
        <li className="mt-4 list-none font-semibold">Includes:</li>
        <li>Instant digital delivery (webform, email, or API)</li>
        <li>
          <Anchor className="anchor-subtle" href="/rights">
            No selling of your data
          </Anchor>
          &mdash;ever
        </li>
        <li>Full control over text&nbsp;notifications</li>
        <li>
          <Anchor className="anchor-subtle" href="/premium/coins">
            Pay with coins
          </Anchor>{' '}
          for postage, faxes, extra deliveries, &amp; campaign boosts
        </li>
        <li>
          Earn coins from rewarded alerts &amp; when others promote{' '}
          <Anchor
            className="anchor-subtle"
            href="/news/2020/01/14/introducing-petitions"
          >
            your&nbsp;campaigns
          </Anchor>
        </li>
        <li>Limited daily deliveries</li>
      </ul>
      <ul
        className="card-flat block list-disc space-y-1 p-8 text-sm marker:text-stone-300 before:text-lg before:font-bold before:content-[attr(aria-label)] sm:basis-1/2 dark:marker:text-stone-600"
        aria-label="Premium"
      >
        <li className="list-none text-lg">
          <strong>${prices.month.formattedAmount}</strong>/month
        </li>
        <li className="list-none font-optical-italic">
          Or pay yearly and get 2 months&nbsp;free&nbsp;🎉
        </li>
        <li className="mt-4 list-none font-semibold">
          Everything in free,&nbsp;plus:
        </li>
        <li>
          <Anchor
            className="anchor-subtle"
            href="/news/2023/07/04/introducing-the-ai-writer"
          >
            AI writing, editing &amp; summaries
          </Anchor>
        </li>
        <li>Unlimited electronic&nbsp;deliveries</li>
        <li>
          Coins every renewal plus 100% bonus{' '}
          <Anchor href="/premium/coins">coins</Anchor> per dollar (half-price
          promotions, postage & faxes)
        </li>
        <li className="mt-4 list-none font-semibold">Exclusive Perks</li>
        <li>
          Limited-edition{' '}
          <Anchor
            className="anchor-subtle"
            href="https://cottonbureau.com/p/S9ARA4/pin/sustaining-donor-pin#/16379916/navy-enamel-1.75in"
          >
            Rosie&nbsp;pin
          </Anchor>{' '}
          (yearly members)
        </li>
        <li>
          Daily{' '}
          <Anchor
            className="anchor-subtle"
            href="/news/2019/06/21/get-three-front-pages-daily"
          >
            front&nbsp;pages
          </Anchor>{' '}
          from major newspapers
        </li>
        <li className="mt-4 list-none font-semibold">Organizing&nbsp;Power</li>
        <li>
          <Anchor
            className="anchor-subtle"
            href="https://news-photos-features.com/wp-content/uploads/2023/02/Santos-Caravan_20230225_153429633e2-c-Karen-Rubin.jpg"
          >
            Custom&nbsp;keyword
          </Anchor>{' '}
          &amp;{' '}
          <Anchor className="anchor-subtle" href="/go/jesscraven101">
            web&nbsp;page
          </Anchor>
        </li>
        <li>
          Text blasts{' '}
          <Anchor
            className="anchor-subtle"
            href="/news/2021/05/06/build-your-following"
          >
            to followers
          </Anchor>{' '}
          when your campaigns&nbsp;launch
        </li>
        <li>Write to state &amp; federal lawmakers at the same&nbsp;time</li>
        <li>Voter registration&nbsp;monitoring</li>
        <li>Weekly texts on bills headed to the Congress&nbsp;floor</li>
        <li>Instant promotion&nbsp;approval</li>
      </ul>
    </div>

    <p className="mt-4 text-center">
      Don’t want to give monthly?{' '}
      <Anchor className="anchor-text" href="/premium/coins">
        Buy coins
      </Anchor>{' '}
      instead!
    </p>
  </>
);

PremiumFeaturesTable.propTypes = {
  prices: PricesPropType.isRequired,
};
